// Supabase 浏览器客户端（仅 anon key，受 RLS 约束）
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!url || !anon) {
  console.warn("缺少 VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY，请检查 .env");
}

export const supabase = createClient(url ?? "", anon ?? "", {
  auth: { persistSession: true, autoRefreshToken: true },
});
